/**
 * Created by Owner on 2016/8/9.
 */
import {Component} from '@angular/core';
import {NavController, AlertController, ViewController, NavParams, LoadingController} from 'ionic-angular';
import {AppConfigService} from "../../services/appConfig.service";
import {BetDetailsPage} from "../betDetails/betDetails";
import {UserService} from "../../services/user.services";
import {DepositDetailPage} from "../../pages/depositDetail/depositDetail";
import { TranslateService } from 'ng2-translate';
@Component({
    templateUrl: 'depositList.html',
    selector: 'deposit-list-page',
})
export class DepositListPage {
    private recordList: any = [];
    private infiniteScrollBoolean: boolean = true;
    private totalNum: number = 0;
    private postData: any;
    stateNameFn: any = {
        0: " Đã gửi",
        1: " Đang xử lý",
        2: " Đang chờ duyệt",
        4: " Thành công",
        5: " Thất bại",
        "-3": "Quá hạn nạp tiền",
        "-2": "Chờ nạp tiền",
        "-5": "Đã hủy"
    };

    constructor(private navParams: NavParams, private nav: NavController, private alertCtrl: AlertController,
                private userService: UserService, public viewCtrl: ViewController,
                private loadingCtrl: LoadingController, private translate: TranslateService) {
        this.postData = navParams.get("postData");
        let data = navParams.get("data");
        this.recordList = this.dataChange(data["reslist"]);
        this.totalNum = data["totalrecord"];
    }

    doRefresh(refresher) {
        this.getFirstData(refresher);
    }

    getFirstData(refresher: any = null) {
        this.userService.depositSearch(this.postData, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.recordList = this.dataChange(data["reslist"]);
                this.totalNum = data["totalrecord"];
                if (refresher) {
                    refresher.complete();
                    this.infiniteScrollBoolean = true;
                }
            }
        });
    }

    doInfinite(infiniteScroll) {
        infiniteScroll.enable(false);
        setTimeout(() => {
            this.userService.depositSearchNext(this.postData, this).then(data => {
                if (!data["msg"]) {
                    let dataTemp = this.dataChange(data["reslist"]);
                    this.recordList = this.recordList.concat(dataTemp);
                    this.totalNum = data["totalrecord"];
                    infiniteScroll.complete();
                    infiniteScroll.enable(true);
                } else {
                    infiniteScroll.enable(true);
                    this.infiniteScrollBoolean = false;
                }
            });
        }, 500);
    }

    dataChange(list: any) {
        list.map(item => {
            let state: any = {
                "-1": this.translate.instant('WAITING_FOR_DEPOSIT'),
                "0": this.translate.instant('PROCESSING'),
                "1": this.translate.instant('WAITING_FOR_APPROVAL'),
                "4": this.translate.instant('SUCCESS'),
                "5": this.translate.instant('REJECTED'),
                "-3": this.translate.instant('DEPOSIT_TIMEOUT'),
                "-2": this.translate.instant('WAITING_FOR_DEPOSIT'),
                "-5": this.translate.instant('CANCELLED')
            };
            let type: any = {
                "1": "Bank Transfer",
                "2": "Online ATM NganLuong",
                "3": "eWallet NganLuong",
                "4": "Online ATM Help2Pay",
                "5": "Cardpay NganLuong"
            };
            item["statusName"] = state[item["status"]];
            item["typeName"] = type[item["type"]];
            item["savetime"] = item["savetime"].replace(/-/g,'/');
            return item;
        });
        return list;
    }

    gotoDetailDeposit(item: any) {
        this.nav.push(DepositDetailPage, {
            paramItem: item
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/depositList/depositList.ts